export default import.meta.ROLLDOWN_FILE_URL_fILS8NDs2l_5K0kkSr$WXQ